import React from 'react';
import Typography from '@material-ui/core/Typography';
import {I18n} from 'react-redux-i18n';
import moment from '../../util/moment';
import PropTypes from 'prop-types';


export default class VideoCardInfo extends React.PureComponent {
  static propTypes = {
    data: PropTypes.shape({
      mediaId: PropTypes.string.isRequired,
      vehicle: PropTypes.string.isRequired,
      driver: PropTypes.string,
      date: PropTypes.number.isRequired,
      address: PropTypes.string,
      status: PropTypes.string,
      driverId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      terminal: PropTypes.string,
      terminalId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }).isRequired,
    // SEE PNVI-5633
    addFilterChipOnDriverClick: PropTypes.func.isRequired,
    addFilterChipOnVehicleClick: PropTypes.func.isRequired,
    addFilterChipOnTerminalClick: PropTypes.func.isRequired,
    locale: PropTypes.string
  };

  static defaultProps = {
    locale: 'en'
  }

  render() {
    const {
      data: {
        mediaId,
        vehicle,
        driver,
        date,
        terminal,
        address,
        driverId,
        terminalId
      },
      addFilterChipOnDriverClick,
      addFilterChipOnVehicleClick,
      addFilterChipOnTerminalClick
    } = this.props;
    const textDate = moment(new Date(date)).format(I18n.t('configuration.dateTimeFormat'));
  
    const handleDriverClick = () => addFilterChipOnDriverClick({
      driver,
      driverId
    });
  
    const handleVehicleClick = () => addFilterChipOnVehicleClick(vehicle);
  
    const handleTerminalClick = () => addFilterChipOnTerminalClick(terminalId);
  
    const renderTerminal = () => {
      return (
        <div>
          <Typography onClick={handleTerminalClick} style={{display: 'initial'}} component="a" className="videoinfo__terminal" id={`videoCardTerminal-${mediaId}`}>{terminal}</Typography>
        </div>
      );
    };
  
    return (
      <div className="videoinfo">
        <div className="videoinfo__line1">
          <Typography onClick={handleVehicleClick} component="a" className="videoinfo__vehicle" id={`videoCardVehicleNumber-${mediaId}`}>
            {vehicle}
          </Typography>
          <Typography component="p" id={`videoCardDate-${mediaId}`}>
            {textDate}
          </Typography>
        </div>
        <div>
          <Typography onClick={handleDriverClick} style={{display: 'initial'}} component="a" className="videoinfo__driver" id={`videoCardDriverName-${mediaId}`}>
            {driver}
          </Typography>
        </div>
        {terminal && renderTerminal()}
        <Typography component="p" className="videoinfo__address" id={`videoCardAddress-${mediaId}`}>
          {address}
        </Typography>
      </div>
    );
  }
}
